// PingTypesExplainer — Feb 2026. Extracted from StagingTab so it can be
// opened from BOTH the Question bank header (context="scheduled") and the
// Calendar Pings header inside the AI Calendar (context="calendar").
// The card matching the caller renders on top; wording follows the new
// "Calendar Pings" naming (renamed from "Organizer pings").
import { X, Shuffle, Bell } from "@phosphor-icons/react";

function ScheduledCard() {
  return (
    <div className="border border-[#B9D4BE] rounded-lg p-4 bg-[#F4F8F5]" data-testid="ping-types-card-scheduled">
      <div className="flex items-center gap-2 mb-1.5">
        <Shuffle size={15} weight="duotone" className="text-[#4A5D4E]" />
        <strong className="text-[#1C1B1A]">Question bank + Scheduled pings — "surprise me"</strong>
      </div>
      <p className="text-xs text-[#1C1B1A] leading-relaxed">
        A push that pulls a question <strong>at random</strong> from your Question bank (or your past
        chats) — great for reflection questions where predictability kills the magic, like
        <em> "what's one kind thing I can do for my wife today?"</em> Fire it at a set time, or use
        <strong> surprise mode</strong> for 1-3 pings at completely random times each day.
      </p>
      <p className="text-[10px] text-[#6B6A68] mt-1.5">Works on any silo with Staging. Blind to your calendar.</p>
    </div>
  );
}

function CalendarCard() {
  return (
    <div className="border border-[#EAD9AE] rounded-lg p-4 bg-[#FDF9EF]" data-testid="ping-types-card-calendar">
      <div className="flex items-center gap-2 mb-1.5">
        <Bell size={15} weight="duotone" className="text-[#C16E5A]" />
        <strong className="text-[#1C1B1A]">Calendar Pings (inside the AI Calendar) — "ask me this exact thing"</strong>
      </div>
      <p className="text-xs text-[#1C1B1A] leading-relaxed">
        One <strong>specific, directed question</strong> pushed to your phone on a real calendar
        schedule — <em>"what's on our agenda today?"</em>, <em>"when's my next date-night opening?"</em>
        Answers are grounded in your <strong>live calendar / Key Data</strong>; they show on the grid,
        roll into monthly archives, and can be assigned to family members.
      </p>
      <p className="text-[10px] text-[#6B6A68] mt-1.5">Personal silos with the AI Calendar. Calendar-aware.</p>
    </div>
  );
}

export default function PingTypesExplainer({ onClose, context = "scheduled" }) {
  const cards = context === "calendar"
    ? [<CalendarCard key="cal" />, <ScheduledCard key="sch" />]
    : [<ScheduledCard key="sch" />, <CalendarCard key="cal" />];
  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4" onClick={onClose} data-testid="ping-types-explainer">
      <div className="bg-[#FDFCF8] rounded-2xl w-full max-w-lg shadow-2xl border hairline max-h-[90dvh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-3 border-b hairline flex items-center justify-between shrink-0">
          <h2 className="font-serif-display text-lg">Two kinds of pings — which one do I want?</h2>
          <button onClick={onClose} className="p-1 rounded hover:bg-[#F0F1EE]" data-testid="ping-types-close"><X size={18} /></button>
        </div>
        <div className="p-5 flex-1 overflow-y-auto space-y-4 text-sm">
          {cards}
          <p className="text-xs text-[#6B6A68] leading-relaxed">
            <strong>Rule of thumb:</strong> random reflection stuff → Question bank + Scheduled pings.
            Anything calendar- or routine-shaped → Calendar Pings. Both open your silo's Q&amp;A with the
            question pre-asked when you tap the notification.
          </p>
        </div>
        <div className="px-5 py-3 border-t hairline shrink-0 pb-[calc(0.75rem_+_env(safe-area-inset-bottom))] flex justify-end">
          <button onClick={onClose} className="text-xs px-4 py-2 rounded-md bg-[#1C1B1A] text-[#FDFCF8]">Got it</button>
        </div>
      </div>
    </div>
  );
}
